import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "list"];

  connect() {
    this._bindInput(this.inputTarget);
  }

  _bindInput(input) {
    input.addEventListener("change", (event) => this._onFileChange(event));
  }

  _onFileChange(event) {
    const input = event.target;
    const files = Array.from(input.files);
    if (!files.length) {
      return;
    }

    files.forEach((file) => {
      const item = document.createElement("span");
      item.className = "tag is-light mr-1 mb-1";
      item.textContent = file.name;
      this.listTarget.appendChild(item);
    });

    // Inject a fresh input so the user can add more files
    const clone = input.cloneNode();
    clone.value = "";
    input.insertAdjacentElement("afterend", clone);
    this._bindInput(clone);
  }
}
